let header = $('header.banner'),
    isDisabled,
    hoverOn,
    menuButton = $('.menu-button'),
    headerLogo = $('.header-nav .company-logo'),
    fullscreenMenu = $('.full-screen-menu'),
    headerPhone = $('.header-phone'),
    headerButton = $('.header-button'),
    headerMenuItemHasChildren = $('header nav .menu > .menu-item-has-children'),
    footerMenuItemHasChildren = $('footer nav .menu > .menu-item-has-children'),
    fullscreenMenuItemHasChildren = $('.full-screen-menu-wrapper nav .menu > .menu-item-has-children');

$(document).on('scroll', function () {
    if ($(this).scrollTop() > 50) {
        header.addClass('scrolled');
        headerPhone.addClass('scrolled');
        headerButton.addClass('scrolled');
        headerLogo.addClass('scrolled');
    } else {
        header.removeClass('scrolled');
        headerPhone.removeClass('scrolled');
        headerButton.removeClass('scrolled');
        headerLogo.removeClass('scrolled');
    }
});

jQuery(function() {
    setTimeout(function () {        
        $('.scrollbar-outer').scrollbar({
            ignoreMobile: true,
            passive: true,
        });
    }, 1000)
})

menuButton.on('click', function () {
    $('body').toggleClass('fix');
    fullscreenMenu.fadeToggle();
    menuButton.toggleClass('opened');
});
function toggleFullscreenDropdownMenu() {
    fullscreenMenuItemHasChildren.bind('click', function (e) {
        if (!isDisabled) {
            if ($(e.target).hasClass('dropdown-toggle')) {
                $(this).children('.dropdown-menu').slideToggle();
                $(this).children('a').toggleClass('open');
            }
        }
    });
    isDisabled = false;
}
if ($(window).width() < 768) {
    isDisabled = false;
    hoverOn = false;
} else {
    isDisabled = true;
    hoverOn = true;
}
if (!isDisabled) {
    fullscreenMenuItemHasChildren.unbind('click');
    toggleFullscreenDropdownMenu();
}
if (hoverOn) {
    footerMenuItemHasChildren.unbind('click');
    footerMenuDropdownHover();
} else {
    footerMenuItemHasChildren.unbind('mouseenter');
    footerMenuItemHasChildren.unbind('mouseleave');
    footerMenuDropdownClick();
}

$(window).on('resize', function () {
    if ($(window).width() < 768) {
        isDisabled = false;
        hoverOn = false;
        fullscreenMenuItemHasChildren.unbind('click');
        toggleFullscreenDropdownMenu();
        footerMenuItemHasChildren.unbind('mouseenter');
        footerMenuItemHasChildren.unbind('mouseleave');
        footerMenuItemHasChildren.unbind('click');
        footerMenuDropdownClick();
    } else {
        isDisabled = true;
        hoverOn = true;
        $('.full-screen-menu-wrapper .menu > .menu-item > .dropdown-menu').css('display', 'grid');
        footerMenuItemHasChildren.unbind('click');
        footerMenuItemHasChildren.unbind('mouseenter');
        footerMenuItemHasChildren.unbind('mouseleave');
        footerMenuDropdownHover();
    }
});
$('.menu-item-has-children > a').on('click', function (e) {
    e.preventDefault();
});
headerMenuItemHasChildren.hover(function () {
    $(this).children('.dropdown-menu').stop().fadeIn();
    if ($(this).hasClass('locations-dropdown')) {
        $(this).find('.dropdown-container').css(
      /* stylelint-disable */

      /* eslint-disable */
      {
        opacity: 0,
        display: 'flex',
      }).stop().animate({
        opacity: 1,
      }, 1000);
    }
}, function () {
    $(this).children('.dropdown-menu').stop().fadeOut();
});

function footerMenuDropdownClick() {
    footerMenuItemHasChildren.bind('click', function () {
        if (!hoverOn) {
            if (!$(this).children('.dropdown-menu').is(':visible')) {
                $(this).children('.dropdown-menu').slideDown();
                $(this).addClass('open');
            } else {
                $(this).children('.dropdown-menu').slideUp();
                $(this).removeClass('open');
            }
        }
    });
}

function footerMenuDropdownHover() {
    footerMenuItemHasChildren.children('.dropdown-menu').slideUp();
    footerMenuItemHasChildren.removeClass('open');
    footerMenuItemHasChildren.bind({
        mouseenter: function () {
            $(this).children('.dropdown-menu').stop().fadeIn();
            if ($(this).hasClass('locations-dropdown')) {
                $(this).find('.dropdown-container').css(
          {
            opacity: 0,
            display: 'flex',
          }).stop().animate({
            opacity: 1,
          }, 1000);
            }

        }, mouseleave: function () {
            $(this).children('.dropdown-menu').stop().fadeOut();
        }
    });
}
/* stylelint-enable */
/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/modules/header.js